/**
 * Removes all whitespace characters that match `\s` regex
 * (e.g. spaces, tabs, etc.) in a string
 */
export function trimWhitespace(text: string) {
  return text.replace(/\s/g, "");
}
